class BaseHelpers {
  _toRawType = (value,) => {
    const _toString = Object.prototype.toString;
    return _toString.call(value,).slice(8, -1,);
  };

  _toCamelCase = (str,) => {
    const arr = str.match(/[a-z]+|\d+/gi,);
    return arr.map((m,i,)=>{
      let low = m.toLowerCase();
      if (i != 0) {
        low = low.split('',).
          map((s,k,) => k == 0 ? s.toUpperCase() : s,).join``;
      }
      return low;
    },).join``;
  };

  _capitalize = (string, lowercaseWords = [],) => {
    if (typeof(string) !== 'string') {
      return string;
    }

    const keepLowercaseList = [
      'a',
      'com',
      'da',
      'das',
      'de',
      'do',
      'dos',
      'e',
      'em',
      'na',
      'nas',
      'no',
      'nos',
      'o',
      'por',
      'sem',
    ];
    const keepLowercase = [...keepLowercaseList, ...lowercaseWords,];
    
    return string.
      split(' ',).
      filter((word,) => !!word,).
      map((word, index,) => {
        const lowercase = word.toLowerCase();
        return (keepLowercase.includes(lowercase,) && index !== 0)
          ? lowercase : `${word.charAt(0,).toUpperCase()}${word.substring(1,).toLowerCase()}`;
      },).
      join(' ',);
  };
}

const baseHelpers = new BaseHelpers();

export default {
  ...baseHelpers,
  install (Vue,) {
    Object.keys(baseHelpers,).
      forEach((method,) => Vue.prototype[method] = baseHelpers[method],);
  },
};
